import { cn } from "@/lib/utils";
import { ClassAttributes, HTMLAttributes } from "react";

export const Separator = ({
    className,
    ...props
}: ClassAttributes<HTMLDivElement> &
    HTMLAttributes<HTMLDivElement> & { className?: string }) => {
    return (
        <div
            className={cn(
                "w-auto border-t-[1.75px] border-line bg-grey-100 dark:bg-grey-50",
                className
            )}
            {...props}
        />
    );
};
